<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title">Order Minor Edits</h4>
    <button type="button" class="btn-close" (click)="activeModal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <div class="mb-3">
      <label class="form-label fw-bold">Description <span class="text-danger">*</span></label>
      <textarea class="form-control" [formControl]="descriptionCtrl" rows="5"
        placeholder="Describe the changes that need to be made..." [formValidation]="descriptionCtrl"></textarea>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss()">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="submit()" [disabled]="isSubmitting">
      @if (isSubmitting) {
        <span class="spinner-border spinner-border-sm me-1"></span>
      }
      Submit
    </button>
  </div>
</div>